export default __webpack_public_path__ + "static/media/avani_logo.0778bb1c.svg";